// gnb
export const PATH_NAME_HOME = 'home'
export const PATH_NAME_VOD = 'vod'
export const PATH_NAME_LIVE = 'live'
export const PATH_NAME_MOVIE = 'movie'
export const PATH_NAME_GLOBAL = 'global'
export const PATH_NAME_CLIP = 'clip'
export const PATH_NAME_POPUP_CHANGE_PAYMENT = 'popupChangePayment'
export const ROUTE_NAME_MAIN_CATEGORY = 'main_category'
export const ROUTE_NAME_SUB_CATEGORY = 'sub_category'

// my
export const PATH_NAME_MY = 'my'
export const PATH_NAME_USE_LIST_VOD_HISTORY = 'use_list_vod_history'
export const PATH_NAME_USE_LIST_MOVIE_HISTORY = 'use_list_movie_history'
export const PATH_NAME_USE_LIST_DOWNLOAD = 'use_list_download'
export const PATH_NAME_LIKE_PROGRAM = 'like_program'
export const PATH_NAME_LIKE_MOVIE = 'like_movie'
export const PATH_NAME_LIKE_CHANNEL = 'like_channel'
export const PATH_NAME_LIKE_THEME = 'like_theme'
export const PATH_NAME_RESERVE_WATCH = 'reserve_watch'
export const PATH_NAME_VOUCHER_LIST_SINGULAR = 'voucher_list_singular'
export const PATH_NAME_VOUCHER_LIST_PACKAGE = 'voucher_list_package'
export const PATH_NAME_SUBSCRIPTION_TICKET = 'subscription_ticket'
export const PATH_NAME_COIN = 'coin'
export const PATH_NAME_COUPON = 'coupon'
export const PATH_NAME_USER_QNA = 'user_qna'
export const PATH_NAME_SUBSCRIPTION_CANCEL = 'subscription_cancel'

// search
export const PATH_NAME_SEARCH = 'search'
export const PATH_NAME_CATEGORY_ADULT_CHECK = 'categoryAdultCheck'
export const PATH_NAME_SEARCH_LIST = 'searchList'
export const PATH_NAME_LIST_ADULT_CHECK = 'listAdultCheck'
export const PATH_NAME_SEARCH_TAG = 'search_tag'
export const PATH_NAME_SEARCH_TAG_GROUP = 'search_tag_group'

// account
export const PATH_NAME_LOGIN = 'login'
export const PATH_NAME_MEMBER_LOGIN = 'member_login'
export const PATH_NAME_T_LOGIN_CALLBACK = 'tlogincallback'
export const PATH_NAME_LOGIN_APPLE_REDIRECT = 'login_apple_redirect'
export const PATH_NAME_LNB_USER_INFO = 'lnbUserInfo'
export const PATH_NAME_LNB_EDIT_USER_PROFILE = 'lnbEditUserProfile'
export const PATH_NAME_LNB_EDIT_USER_ONE_OF_PROFILE = 'lnbEditUserOneOfProfile'
export const PATH_NAME_ALARM_NOTICE_LIST = 'alarmNoticeList'
export const PATH_NAME_ADULT_SETTINGS = 'adultSettings'
export const PATH_NAME_ADULT_CHILDREN_SETTINGS = 'adultChildrenSettings'
export const PATH_NAME_ADULTVERIFY = 'adultverify'
export const PATH_NAME_EXTERNAL_ADULTVERIFY = 'external_adultverify'
export const PATH_NAME_ADULTVERIFY_UNLOCK = 'adultverify_unlock'
export const PATH_NAME_ADULTVERIFY_PIN_CHILDREN = 'adultverify_pin_children'
export const PATH_NAME_ADULTVERIFY_PIN_ADULT = 'adultverify_pin_adult'
export const PATH_NAME_ADULTVERIFY_PIN_ADULT_COMPLETE =
  'adultverify_pin_adult_complete'

// customer
export const PATH_NAME_CUSTOMER = 'customer'
export const PATH_NAME_FAQ = 'faq'
export const PATH_NAME_NOTICE_LIST = 'notice_list'
export const PATH_NAME_NOTICE_VIEW = 'notice_view'
export const PATH_NAME_CUSTOMER_USER_QNA = 'customer_user_qna'

// event
export const PATH_NAME_EVENT = 'event'
export const PATH_NAME_EVENT_LIST = 'event_list'
export const PATH_NAME_EVENT_DETAIL = 'event_detail'
export const PATH_NAME_BOARD = 'board'
export const PATH_NAME_BOARD_DETAIL_VIEW = 'board_detail_view'
export const PATH_NAME_EVENT_EMERGENCY = 'event_emergency'

// voucher
export const PATH_NAME_VOUCHER = 'voucher'
export const PATH_NAME_VOUCHER_INDEX = 'voucher_index'
export const PATH_NAME_REGIST = 'regist'
export const PATH_NAME_WAVVEON = 'wavveon'
export const PATH_NAME_VOUCHER_PROMOTION = 'voucher_promotion'
export const PATH_NAME_TERMS_COIN_CHARGE_FOR_GOOGLE_IN_APP =
  'terms_coin_charge_for_google_in_app'
export const PATH_NAME_SUBS_COIN_CHARGE_FOR_GOOGLE_IN_APP =
  'subs_coin_charge_for_google_in_app'
export const PATH_NAME_COIN_CHARGE_FOR_DCB = 'coin_charge_for_dcb'
export const PATH_NAME_VOUCHER_POPUP_NEW_FOR_APP = 'voucher_popup_new_for_app'
export const PATH_NAME_REVOCATION_DEFENCE = 'revocation_defense'
export const PATH_NAME_VOUCHER_POPUP_INFO = 'voucher_popup_info'

// agreement
export const PATH_NAME_AGREEMENT = 'agreement'
export const PATH_NAME_SERVICE = 'service'
export const PATH_NAME_PAID = 'paid'
export const PATH_NAME_PRIVACY = 'privacy'
export const PATH_NAME_YOUTH = 'youth'
export const PATH_NAME_POOQZONE_VOUCHER = 'pooqzone_voucher'
export const PATH_NAME_POOQZONE_PRIVACY = 'pooqzone_privacy'

// list
export const PATH_NAME_LIST = 'list'
export const PATH_NAME_INSTANTPLAY_LIST = 'instant-play-list'
export const PATH_NAME_SUPERMULTISECTION = 'supermultisection'
export const PATH_NAME_SUPERMULTISECTION_WITH_API = 'supermultisection-with-api'
export const PATH_NAME_THEME_MOVIE = 'theme-movie'
export const PATH_NAME_THEME_VOD = 'theme-vod'

// list view more
export const PATH_NAME_LIST_VIEW_MORE = 'list_view_more'

// other
export const PATH_NAME_PLAYER = 'player'
export const PATH_NAME_SCHEDULE = 'schedule'
export const PATH_NAME_WAVVEON_INTRO = 'wavveonintro'
export const PATH_NAME_SHORT_CUT_SMS = 'short_cut_sms'
export const PATH_NAME_WAVVIE_POPUP = 'wavvie_popup'
export const PATH_NAME_WAITING_SERVICE = 'waitingService'
export const PATH_NAME_ROUTER_TEST = 'router_test'
export const PATH_NAME_COVER = 'cover_page'

// signup
export const PATH_NAME_SIGNUP_REDIRECT = 'path_name_signup_reidrect'

export const PATH_NAME_PLAYER_VOD_DETAIL_INFO = 'player_vod_detail_info'
export const PATH_NAME_PLAYER_MOVIE_DETAIL_INFO = 'player_movie_detail_info'
// baseball
export const PATH_NAME_NOT_SUPPORT_MOBILE_WEB = 'NotSupportMobileWeb'

// redirect
export const PATH_NAME_INDEX_REDIRECT = 'indexRedirect'
export const PATH_NAME_LOGIN_REDIRECT_HTML = 'loginRedirecthtml'
export const PATH_NAME_LOGIN_REDIRECT = 'loginRedirect'
export const PATH_NAME_PROFILE = 'profile'
export const PATH_NAME_CUSTOMER_NOTICE_VIEW_FOR_APP =
  'customer_notice_view_for_app'
export const PATH_NAME_SEARCH_REDIRECT = 'search_redirect'
export const PATH_NAME_MOVIE_PLAYER_REDIRECT = 'movie_player_redirect'
export const PATH_NAME_VOD_PLAYER_REDIRECT = 'vod_player_redirect'
export const PATH_NAME_LIVE_PLAYER_REDIRECT = 'live_player_redirect'
export const PATH_NAME_TEMP_SUBSCRIPTION_COIN_FOR_ANDROID =
  'temp_subscription_coin_for_android'
export const PATH_NAME_VOUCHER_RECOMMEND_FOR_IOS_201802 =
  'voucher_recommend_for_ios_201802'
export const PATH_NAME_VOUCHER_RECOMMEND_FOR_IOS = 'voucher_recommend_for_ios'
export const PATH_NAME_VOUCHER_RECOMMEND_ANDROID = 'voucher_recommend_android'
export const PATH_NAME_VOUCHER_ALL_FOR_IOS_201802 = 'voucher_all_for_ios_201802'
export const PATH_NAME_VOUCHER_ALL_FOR_IOS = 'voucher_all_for_ios'
export const PATH_NAME_VOUCHER_ALL_FOR_ANDROID = 'voucher_all_for_android'
export const PATH_NAME_VOUCHER_PARTNER_FOR_ANDROID =
  'voucher_partner_for_android'
export const PATH_NAME_VOUCHER_REGIST_FOR_ANDROID = 'voucher_regist_for_android'
export const PATH_NAME_CUSTOMER_AGREEMENT_REDIRECT =
  'customer_agreement_redirect'
export const PATH_NAME_CUSTOMER_EVENT_LIST = 'customer_event_list'
export const PATH_NAME_CUSTOMER_EVENT_VIEW_FOR_APP =
  'customer_event_view_for_app'
export const PATH_NAME_CUSTOMER_EVENT_VIEW_REDIRECT =
  'customer_event_view_redirect'
export const PATH_NAME_CUSTOMER_EVENT_BOARD_LIST = 'customer_event_board_list'
export const PATH_NAME_CUSTOMER_EVENT_BOARD_VIEW_FOR_APP =
  'customer_event_board_view_for_app'
export const PATH_NAME_CUSTOMER_EVENT_BOARD_VIEW_REDIRECT =
  'customer_event_board_view_redirect'
export const PATH_NAME_EVENT_LIST_DEEP_LINK = 'event_list_deep_link'
export const PATH_NAME_CUSTOMER_AGREEMENT_HTML_REDIRECT =
  'customer_agreement_html_redirect'
export const PATH_NAME_MYPOOQ_INDEX_REDIRECT = 'mypooq_index_redirect'
export const PATH_NAME_MYPOOQ_REDIRECT = 'mypooq_redirect'
export const PATH_NAME_WAVVE_LINK_CUSTOMER_NOTICE_VIEW =
  'link_wavve_customer_view'
export const PATH_NAME_WAVVE_LINK_EVENT_VIEW = 'link_wavve_event_view'
// promotion

export const PATH_NAME_PROMOTION_USER = 'promotion_user'

// notFound
export const PATH_NAME_NOT_FOUND = 'NotFound'

// DisableBottomTabList
export const DISABLE_BOTTOM_TAB_ROUTE_NAME_LIST = [
  PATH_NAME_LNB_USER_INFO,
  PATH_NAME_SCHEDULE,
  PATH_NAME_ADULTVERIFY_UNLOCK,
  PATH_NAME_ADULTVERIFY_PIN_CHILDREN,
  PATH_NAME_LIST_ADULT_CHECK,
  PATH_NAME_ADULTVERIFY,
  PATH_NAME_CATEGORY_ADULT_CHECK,
  PATH_NAME_LNB_EDIT_USER_PROFILE,
  PATH_NAME_LNB_EDIT_USER_ONE_OF_PROFILE,
  PATH_NAME_NOT_FOUND,
  PATH_NAME_ADULTVERIFY_PIN_ADULT,
  PATH_NAME_ADULTVERIFY_PIN_ADULT_COMPLETE,
  PATH_NAME_NOT_SUPPORT_MOBILE_WEB,
  // 이용권, 이용권내 팝업, 이용권팝업
  PATH_NAME_VOUCHER_INDEX,
  PATH_NAME_REGIST,
  PATH_NAME_WAVVEON,
  PATH_NAME_VOUCHER_PROMOTION,
  PATH_NAME_VOUCHER_POPUP_INFO,
  PATH_NAME_VOUCHER_POPUP_NEW_FOR_APP,
  // 고객센터
  PATH_NAME_FAQ,
  PATH_NAME_NOTICE_LIST,
  PATH_NAME_NOTICE_VIEW,
  PATH_NAME_CUSTOMER_USER_QNA,
  // 이용약관
  PATH_NAME_SERVICE,
  PATH_NAME_PAID,
  PATH_NAME_PRIVACY,
  PATH_NAME_YOUTH,
  PATH_NAME_POOQZONE_VOUCHER,
  PATH_NAME_POOQZONE_PRIVACY,
  // 이벤트
  PATH_NAME_EVENT_LIST,
  PATH_NAME_EVENT_DETAIL,
  PATH_NAME_BOARD,
  PATH_NAME_BOARD_DETAIL_VIEW,
  // my 알람, 설정, 취향분석
  PATH_NAME_ALARM_NOTICE_LIST,
  PATH_NAME_ADULT_SETTINGS,
  PATH_NAME_ADULT_CHILDREN_SETTINGS,
  // my
  PATH_NAME_SUBSCRIPTION_TICKET,
  PATH_NAME_COIN,
  PATH_NAME_COUPON,
  PATH_NAME_VOUCHER_LIST_SINGULAR,
  PATH_NAME_VOUCHER_LIST_PACKAGE,
  PATH_NAME_USE_LIST_DOWNLOAD,
  PATH_NAME_WAVVEON_INTRO,
  // login
  PATH_NAME_LOGIN,
  // cover page
  PATH_NAME_COVER,
  // player
  PATH_NAME_PLAYER,
  PATH_NAME_PLAYER_VOD_DETAIL_INFO,
  PATH_NAME_PLAYER_MOVIE_DETAIL_INFO,
  // 구글 인앱 코인
  PATH_NAME_TERMS_COIN_CHARGE_FOR_GOOGLE_IN_APP,
  PATH_NAME_SUBS_COIN_CHARGE_FOR_GOOGLE_IN_APP,
]
